
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import {  message, Divider, Table, Tooltip, Switch  } from "antd";
import prettysize from '../../../../src/utils';
import moment from 'moment';

import CreateTransferReport from './EachTransfer/eachTransfer';
import { on_migration_progress, clear_migration, refresh_migrations_history, aws_migrations_history,aws_migrations_retry} from "../../../actions/migrations";
import {refresh_rm, refresh_profile}   from "../../../actions/auth";

import "./recentTransfer.scss";
class RecentTransfer extends Component{
    constructor(props) {
        super(props)
        
        this.state = {
            awshistory: [],
            user:{},
            migration:{},
            migrations:{},
            disabledRetry:[],
            downloadUrl:null,
            history : [],
        }
    }
    
    componentDidMount() {
        this.props.aws_migrations_history(3)
        // this.props.aws_migrations_history(this.props.user.id)
        // this.props.refresh_migrations_history()
        // this.props.refresh_rm()
        // this.stats_loop()
    }

    componentWillReceiveProps(props) {
        this.setState({migrations:props.ongoing, history:props.history, awshistory:props.awshistory, user:props.user, awsLoading:props.awsLoading})
        // console.log("migrations", props.awshistory);
    }

    render(){
        // console.log("hi in recent trabsfer", this.state);
        const { user } = this.props;
        let counter = 0;

        let {speeds, speed_stat={}, transferred_stat={}, remaining_stat={},
        history:{today:today_history=[], yesterday:yesterday_history=[], week:week_history=[]}={},
        awshistory, migrations={}, downloadUrl, awsLoading} = this.state


        const columns = [
            {
              title: 'Source',
              dataIndex: 'source',
              key: 'source',
              ellipsis: {
                showTitle: false,
              },              
              render: source => (
                <Tooltip placement="topLeft" title={source}>
                  {source}
                </Tooltip>
              ),
              width: 160,
            },
            {
                title: 'Destination',
                dataIndex: 'destination',
                key: 'destination',
                ellipsis: {
                    showTitle: false,
                  },                
                render: destination => (
                  <Tooltip placement="topLeft" title={destination}>
                    {destination}
                  </Tooltip>
                ),
                width: 160,
            },            
            {
              title: 'Total Size',
              dataIndex: 'totalSize',
              key: 'totalSize',
              width: 120,
            },
            {
              title: 'Transferred size',
              dataIndex: 'transferredSize',
              key: 'transferredSize',
              width: 130,
            },
            {
              title: 'Date',
              dataIndex: 'date',
              key: 'date',
              width: 120,
            },
            {
              title: 'Transferred',
              dataIndex: 'transferred',
              key: 'transferred',
              width: 100,
            },
            {
              title: 'Skipped',
              dataIndex: 'skipped',
              key: 'skipped',
              width: 100,
            },
            {
              title: 'Failed',
              dataIndex: 'failed',
              key: 'failed',
              width: 100,
            },

          ];

          
        let data = awshistory?.data?.slice(0, 20).map((t,index) => {
            return {
                source: t.sourceCloudAccount.name + ' > ' + t.sourceBucket,
                destination: t.destinationCloudAccount.name + ' > ' + t.destinationBucket,
                totalSize: prettysize(t.totalSize),
                transferredSize: prettysize(t.transferredSize),
                date: moment(t.requestDate).format('MM/DD/YYYY'),
                transferred: t.transferred,
                skipped: t.skipped,
                failed: t.failed
            }
        })


        const recentTransferTableHeader = <ul>
                                            <li>Source</li>
                                            <li>Destination</li>
                                            <li>Total Size</li>
                                            <li>Transferred size</li>
                                            <li>Date</li>
                                            <li>Transferred</li>
                                            <li>Skipped</li>
                                            <li>Failed</li>
                                        </ul>

        return(
            <div className="recent-transfer-wrapper">
                <div className="header">
                    <h3>Recent Transfers</h3>
                    {/* <h4><a href="">More...</a></h4> */}
                </div>
                <div>
                    <Table columns={columns} dataSource={data} pagination={false} scroll={{ y: 400 }} />
                </div>

            </div>
        )
    }
}
export default withRouter(connect(({migrations={},auth}) => ({
    user : auth.user,
    ongoing:migrations.ongoing, 
    history:migrations.history, 
    awshistory:migrations.awshistory, 
    awsLoading:migrations.awsLoading}), dispatch => 
    bindActionCreators({
        on_migration_progress, 
        clear_migration, 
        refresh_migrations_history, 
        aws_migrations_history, 
        refresh_rm, 
        refresh_profile, 
        aws_migrations_retry}, dispatch))(RecentTransfer))
// export default withRouter(
//     connect(
//     //   mapStateToProps,
//     //   mapDispatchToProps
//     )(RecentTransfer)
//   );